import React, {useEffect, useState} from "react";
import {appSettings, useForceUpdate} from "../../services/misc.functions";
import {useParams} from "react-router-dom";
import {isMobile} from "../../App";

const tabs = [
    {value: 0, label: "CANLI TV"},
    {value: 1, label: "CANLI TV (Yurt Dışı)"},
];


let width: any = 0;

export function Stream() {
    const params = useParams();
    const [selectedTab, setSelectedTab] = useState<any>(params?.tab ? Number(params?.tab) : 0);
    const forceUpdate = useForceUpdate();

    useEffect(() => {
        videoWrapper = document.getElementById("id_video_wrapper");
        if (videoWrapper) {
            width = videoWrapper.offsetWidth;
            forceUpdate();
        }

        window.addEventListener('resize', resizeWindow);
        return () => {
            window.removeEventListener('resize', resizeWindow);
        };
    }, []);

    const resizeWindow = () => {
        if (width !== window.innerWidth) {
            if (videoWrapper) {
                width = videoWrapper.offsetWidth;
            }
            forceUpdate();
        }
    }

    let videoWrapper = document.getElementById("id_video_wrapper");

    return (<>
        <div className="stream-wrapper">
            <div className="container ">
                <div className="stream-pills">
                    <div className={`stream-pill ${selectedTab === 0 ? 'active' : ''}`} onClick={() => {
                        setSelectedTab(0);
                        try {
                            // @ts-ignore
                            dataLayer.push({
                                event: "watch_tjk",
                                button_name: 'Yurt İçi',
                            });
                        } catch (e) {
                        }

                    }}>
                        <span
                            className={`${isMobile ? '' : 'text-xsmall text-bold'} ${!isMobile && selectedTab == 0 ? 'text-primary' : 'text-white'}`}>Yurt İçi Yayın</span>
                    </div>
                    <div className={`stream-pill ${!isMobile ? 'right' : ''}  ${selectedTab === 1 ? 'active' : ''}`}
                         onClick={() => {
                             setSelectedTab(1);
                             try {
                                 // @ts-ignore
                                 dataLayer.push({
                                     event: "watch_tjk",

                                     button_name: 'Yurt Dışı',
                                 });
                             } catch (e) {

                             }
                         }}>
                        <span
                            className={`${isMobile ? '' : 'text-xsmall text-bold'} ${!isMobile && selectedTab == 1 ? 'text-primary' : 'text-white'}`}>Yurt Dışı Yayın</span>
                    </div>
                </div>
            </div>
        </div>
        <div className="container px-0">
            <div className="mt-3 mb-5" id={"id_video_wrapper"}>
                <p className="text-lg text-primary text-bolder mb-3">
                    {selectedTab === 0 ?
                        'CANLI TV Yayını' : 'CANLI TV Yurt Dışı Yayını'}
                    <div className="mt-2 w-25 mx-auto ">
                        {selectedTab === 0 &&
                            <a href={appSettings?.["LIVE_STREAM_DOMESTIC"] ?? "https://www.youtube.com/live/2ZulUer8BVM?si=_Vl-5HxJETgffITv"} target={"_blank"}
                               rel="noreferrer"
                               className="button text-bold secondary w-100 py-3">
                                Canlı izle
                            </a>}
                        {selectedTab === 1 &&
                            <a href={appSettings?.["LIVE_STREAM_ABROAD"] ?? "https://www.youtube.com/live/N6voTQELtbU"} target={"_blank"}
                               rel="noreferrer"
                               className="button text-bold secondary w-100 py-3">
                                Canlı izle
                            </a>}
                    </div>
                </p>
                {/*{selectedTab === 0 ?*/}
                {/*    <iframe width={width} height={width * 315 / 560}*/}
                {/*            src="https://www.youtube.com/embed/g89RQMJtK6E?si=J7XW7PSxljzq0C64?controls=1&showinfo=0&rel=0&autoplay=1&loop=1&mute=1"*/}
                {/*            title="YouTube video player" frameBorder="0"*/}
                {/*            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"*/}
                {/*            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>*/}
                {/*    : <iframe width={width} height={width * 315 / 560}*/}
                {/*              src="https://www.youtube.com/embed/ri4rR0H2i9c?controls=1&showinfo=0&rel=0&autoplay=1&loop=1&mute=1"*/}
                {/*              title="YouTube video player" frameBorder="0"*/}
                {/*              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"*/}
                {/*              allowFullScreen></iframe>}*/}
            </div>
        </div>
    </>)
}
